import api from '@/api';
import { API_BASE_URL } from '..';
import {
  BankConciliationReadTransactionsResponse,
  ConciliatesRequest,
  ReadTransactionsRequest,
} from './BankConciliation.types';

const baseUrl = `${API_BASE_URL}/bank-conciliation`;

export async function bankConciliationReadTransactions(
  data: ReadTransactionsRequest,
) {
  const formData = new FormData();

  formData.append(`file`, data.file);
  formData.append(`bankAccountId`, `${data.bankAccountId}`);

  const result = (await api.post(
    `${baseUrl}/read-transactions-file`,
    formData,
    null,
    {
      contentType: 'multpart/form-data',
    },
  )) as unknown;

  return result as BankConciliationReadTransactionsResponse;
}

export async function conciliate(obj: ConciliatesRequest) {
  const result = (await api.post(
    `${baseUrl}/conciliate`,
    obj,
    null,
  )) as unknown;

  return result;
}
